import { ReloadOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Form, Row, Tabs
} from "antd";
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import BackButton from "../../../commons/BackButton";
import { ROOT_URL } from "../../../constants/api";
import { nofication } from '../../../commons/Nofication';
import Upload from '../../../commons/Upload';
import TakeCareForm from '../../../components/form/TakeCareForm';
import MainLayout from "../../../components/mainLayout";
import { authApis } from "../../../services/authApi";
import "./index.scss";

const { TabPane } = Tabs;
const onChange = (key) => {
    console.log(key);
};
const Register = () => {
    const [fileList, setFileList] = useState();
    const [imageUrl, setImageUrl] = useState();
    const [content, setContent] = useState({
        content_vi: "",
        // content_en: "",
        // content_kr: "",
        // content_cn: "",
        // content_jp: "",
    });
    const [growth_potential, setGrowth_potential] = useState({
        growth_potential_vi: "",
        // growth_potential_en: "",
        // growth_potential_kr: "",
        // growth_potential_cn: "",
        // growth_potential_jp: "",
    });
    const [text_right, setText_right] = useState({
        text_right_vi: "",
        // text_right_en: "",
        // text_right_kr: "",
        // text_right_cn: "",
        // text_right_jp: "",
    });
    const [form] = Form.useForm();
    let { id } = useParams();

    const onChangeContentValue = (lang) => {
    }
    const onChangeGrowthPotentialValue = (lang) =>{

    }
    const onChangeTextRightValue = (lang) => {
    }
    useEffect(() => {
        if (id) {
            authApis
            .getStaticPage(id)
            .then((data) => {
                if (data.status_code === 200) {
                    form.setFieldsValue(data.banner)
                    form.setFieldsValue({ fields: data.statices })
                    setContent({
                        content_vi: data.banner?.content_vi ?? '<p></p>',
                        // content_en: data.banner?.content_en ?? '<p></p>',
                        // content_kr: data.banner?.content_kr ?? '<p></p>',
                        // content_cn: data.banner?.content_cn ?? '<p></p>',
                        // content_jp: data.banner?.content_jp ?? '<p></p>',
                    });
                    setGrowth_potential({
                        growth_potential_vi: data.banner?.growth_potential_vi ?? '<p></p>',
                        // growth_potential_en: data.banner?.growth_potential_en ?? '<p></p>',
                        // growth_potential_kr: data.banner?.growth_potential_kr ?? '<p></p>',
                        // growth_potential_cn: data.banner?.growth_potential_cn ?? '<p></p>',
                        // growth_potential_jp: data.banner?.growth_potential_jp ?? '<p></p>',
                    });
                    setText_right({
                        text_right_vi: data.banner?.text_right_vi ?? '<p></p>',
                        // text_right_en: data.banner?.text_right_en ?? '<p></p>',
                        // text_right_kr: data.banner?.text_right_kr ?? '<p></p>',
                        // text_right_cn: data.banner?.text_right_cn ?? '<p></p>',
                        // text_right_jp: data.banner?.text_right_jp ?? '<p></p>',
                    });
                    setImageUrl(data.banner?.image ? ROOT_URL + data.banner.image : '')
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
            });
        }
    }, [id]);

    const onFinish = async () => {
        const values = form.getFieldValue();
        values.logo = undefined;
        const formData = new FormData();
        for (var key in values) {
            if (key === 'content_vi' || key === 'content_en' || key === 'content_kr' || key === 'content_cn' || key === 'content_jp' || key === 'growth_potential_vi' || key === 'growth_potential_en' || key === 'growth_potential_kr' || key === 'growth_potential_cn' || key === 'growth_potential_jp' || key === 'text_right_vi' || key === 'text_right_en' || key === 'text_right_kr' || key === 'text_right_cn' || key === 'text_right_jp') {
                formData.append(key, values[key]?.editor ? values[key]?.editor.getData() : values[key]);
            } else {
                formData.append(key, values[key]);
            }
            if (key === 'fields'){
                formData.append(key, JSON.stringify(values[key]));
            }
        }
        id && formData.append('id', id);
        formData.append('logo', fileList);
        formData.append('imageUrl', imageUrl)
        await authApis
            .addStaticPage(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    nofication('success', 'Thành công', 'Cập nhật thành công!');
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors)
            });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title="Chăm sóc học sinh"
            link="/why-choose/"
            titleNew="Chăm sóc học sinh"
        >
            <Form form={form} layout="vertical" onFinish={onFinish} colon={true}>
                <Row gutter={16}>
                    <Col span={24} className='pad'>
                        <div className="box-class">
                            <Tabs defaultActiveKey="1" onChange={onChange}>
                                <TabPane tab="Tiếng việt" key="1">
                                    <TakeCareForm lang={'vi'} onChangeContentValue={onChangeContentValue} content={content} onChangeGrowthPotentialValue={onChangeGrowthPotentialValue} growth_potential={growth_potential} text_right={text_right} onChangeTextRightValue={onChangeTextRightValue} id={id} isBanner={false}/>
                                </TabPane>
                            </Tabs>
                            <Form.Item label="Banner" colon={true}>
                                <Upload imageUrl={imageUrl} setFileList={setFileList} setImageUrl={setImageUrl} span={24} />
                            </Form.Item>
                            <Form.Item>
                                <Row
                                    justify="space-between"
                                    style={{ marginTop: 30 }}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Col>
                                    <Col>
                                        <BackButton/>
                                    </Col>
                                </Row>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>
        </MainLayout>
    );
};

export default Register;
